import { TReview } from 'types/review';
const MAX_REVIEWS = 800;

export const getReviewsURL = ({
  apiUrlV3,
  slug,
}: {
  apiUrlV3: string;
  slug: string;
}) => `${apiUrlV3}/web/reviews?slug=${slug}&limit=${MAX_REVIEWS}`;

export const getAverageRating = (reviews: TReview[] = []) => {
  if (reviews.length === 0) {
    return 0;
  }

  const sum = reviews.reduce((acc, x) => acc + x.rating, 0);

  return sum / reviews.length;
};
